"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearUserTokensFromSessionStorage = exports.saveUserTokensToSessionStorage = exports.readUserTokensFromSessionStorage = void 0;
const SdkError_1 = __importDefault(require("../shared/SdkError"));
let tempSessionStorage = {};
// NOTE: isBrowser is defined in this way because in EXPO
//       typeof document === object
//       typeof window === object
const isBrowser = typeof navigator !== 'undefined' && navigator.product !== 'ReactNative';
const isTestEnvironment = process.env.NODE_ENV === 'test';
function readUserTokensFromSessionStorage(userPoolId) {
    const sessionStorageKey = userPoolId;
    let sessionStorageObject;
    if (isBrowser) {
        sessionStorageObject = window.sessionStorage.getItem(sessionStorageKey);
    }
    if (isTestEnvironment) {
        sessionStorageObject = tempSessionStorage[sessionStorageKey];
    }
    if (!sessionStorageObject) {
        throw new SdkError_1.default('COR-9');
    }
    return JSON.parse(sessionStorageObject);
}
exports.readUserTokensFromSessionStorage = readUserTokensFromSessionStorage;
function saveUserTokensToSessionStorage(userPoolId, cognitoUserTokens) {
    const sessionStorageKey = userPoolId;
    const sessionStorageObject = JSON.stringify(cognitoUserTokens);
    if (isBrowser) {
        window.sessionStorage.setItem(sessionStorageKey, sessionStorageObject);
    }
    if (isTestEnvironment) {
        tempSessionStorage[sessionStorageKey] = sessionStorageObject;
    }
}
exports.saveUserTokensToSessionStorage = saveUserTokensToSessionStorage;
function clearUserTokensFromSessionStorage(userPoolId) {
    const sessionStorageKey = userPoolId;
    if (isBrowser) {
        window.sessionStorage.removeItem(sessionStorageKey);
    }
    if (isTestEnvironment) {
        tempSessionStorage = {};
    }
}
exports.clearUserTokensFromSessionStorage = clearUserTokensFromSessionStorage;
//# sourceMappingURL=sessionStorageHandler.js.map